import { RSAA } from 'redux-api-middleware';
import { createRsaaTypes, createHeaders } from '../actionHelpers';
import queryString from 'query-string';

export const ADMIN_ROUND_REPORTS_SEARCH = 'ADMIN_ROUND_REPORTS_SEARCH';
export const ADMIN_ROUND_REPORTS_SEARCH_SUCCESS = 'ADMIN_ROUND_REPORTS_SEARCH_SUCCESS';
export const ADMIN_ROUND_REPORTS_SEARCH_FAILURE = 'ADMIN_ROUND_REPORTS_SEARCH_FAILURE';

export const ADMIN_ROUND_REPORTS_SET_SEARCH_PARAMETERS = 'ADMIN_ROUND_REPORTS_SET_SEARCH_PARAMETERS';

export const searchRoundReports = searchParameters => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_ROUND_REPORTS_SEARCH),
        endpoint: `/api/admin/roundReports?${queryString.stringify(searchParameters)}`,
        headers: createHeaders(false),
        method: 'GET'
    }
});

export const setSearchParameters = searchParameters => ({
    type: ADMIN_ROUND_REPORTS_SET_SEARCH_PARAMETERS,
    searchParameters
});
